import script from "./FormInvoicePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./FormInvoicePreview.vue?vue&type=script&setup=true&lang=js"

import "./FormInvoicePreview.vue?vue&type=style&index=0&id=d4473612&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4473612"]])

export default __exports__